import { ImpactType } from '../../types';

export const NUMBER_DESCRIPTOR_DATA_TYPE = 'NUMBER' as const;

export const EVENTS = {
    KEY_DOWN: 'keydown',
} as const;

export const KEYS = {
    ESCAPE: 'Escape',
    ENTER: 'Enter',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    LOWER_I: 'i',
} as const;

export const DEFAULT_IMPACT_VALUES: ImpactType = {
    addedDescriptors: [],
    addedReports: [],
    updatedReports: [],
    descriptorToRow: {},
};
